// Simple utility to store and access subscription status
// This allows non-React components to access subscription status
let subscriptionStatus = null;

export const setSubscriptionStatus = (status) => {
  subscriptionStatus = status;
};

export const getSubscriptionStatus = () => {
  return subscriptionStatus;
};
